import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import { AllPastExecutionsResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useAllPastExecutions = (
  pageTable: number,
  resultsPerPage: number = 20,
  searchTerm?: string
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, AllPastExecutionsResponse>(
    ["executions", "past", pageTable],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage,
        searchTerm,
      };

      if (!searchTerm) {
        delete query.searchTerm;
      }
      const data = await axiosClient.get<AllPastExecutionsResponse>(
        `/execution/getAll/past?${qs.stringify(query)}`
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      keepPreviousData: true,
      enabled: false,
    }
  );
};
